import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import ".././inner.css";
import Carousel from "react-bootstrap/Carousel";
import { memo } from "react";

function Slider() {
  return (
    <Carousel>
      <Carousel.Item>
        <div className="big">
          <img
            className="d-block w-100"
            src="/photo/Viksha-DB-3.webp"
            alt="Second slide"
          />
        </div>
        <div className="small">
          <img
            className="d-block w-100"
            src="/photo/Viksha-DB-3 mobile banner.webp"
            alt="First slide"
          />
        </div>

        <Carousel.Caption></Carousel.Caption>
      </Carousel.Item>

      <Carousel.Item>
        <div className="big">
          <img
            className="d-block w-100"
            src="../photo/under.jpg"
            alt="First slide"
          />
        </div>
        <div className="small">
          <img
            className="d-block w-100"
            src="../photo/fister.jpg"
            alt="First slide"
          />
        </div>
        <Carousel.Caption></Carousel.Caption>
      </Carousel.Item>

      <Carousel.Item>
        <div className="big">
          <img
            className="d-block w-100"
            src="/photo/Viksha-DB-1.webp"
            alt="Second slide"
          />
        </div>
        <div className="small">
          <img
            className="d-block w-100"
            src="/photo/Viksha-MB-1.webp"
            alt="First slide"
          />
        </div>

        <Carousel.Caption></Carousel.Caption>
      </Carousel.Item>

      <Carousel.Item>
        <div className="big">
          <img
            className="d-block w-100"
            src="/photo/Viksha-DB-2.webp"
            alt="Second slide"
          />
        </div>
        <div className="small">
          <img
            className="d-block w-100"
            src="/photo/Viksha-DB-2 mobile banner.webp"
            alt="First slide"
          />
        </div>

        <Carousel.Caption></Carousel.Caption>
      </Carousel.Item>

      <Carousel.Item>
        <div className="big">
          <img
            className="d-block w-100"
            src="../photo/svchgsgfvhsc.jpg"
            alt="First slide"
          />
        </div>
        <div className="small">
          <img
            className="d-block w-100"
            src="../photo/server.jpg"
            alt="First slide"
          />
        </div>
        <Carousel.Caption></Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <div className="big">
          <img
            className="d-block w-100"
            src="../photo/oooooo.jpg"
            alt="Second slide"
          />
        </div>
        <div className="small">
          <img
            className="d-block w-100"
            src="../photo/ttttt.jpg"
            alt="First slide"
          />
        </div>

        <Carousel.Caption></Carousel.Caption>
      </Carousel.Item>

      {/* <Carousel.Item>
      <div className="big">
        <img
          className="d-block w-100"
          src="../photo/oooo.jpg"
          alt="First slide"
        />
      </div>
      <div className="small">
        <img
          className="d-block w-100"
          src="../photo/ooooo.jpg"
          alt="First slide"
        />
        </div>
        <Carousel.Caption>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
      <div className="big">
        <img
          className="d-block w-100"
          src="../photo/fine.jpg"
          alt="Second slide"
        />
        </div>
      <div className="small">
        <img
          className="d-block w-100"
          src="../photo/subbannertwo.jpg"
          alt="First slide"
        />
        </div>

        <Carousel.Caption>
        </Carousel.Caption>
      </Carousel.Item> */}
    </Carousel>
  );
}

export default memo(Slider);
